import { RNG } from "rot-js";
import { Bounds } from "../../../engine/space/bounds";

export const getRandomInBounds = (rng: typeof RNG, bounds: Bounds) => {
  return {
    x: rng.getUniformInt(bounds.x + 1, bounds.x + bounds.w - 2),
    y: rng.getUniformInt(bounds.y + 1, bounds.y + bounds.h - 2),
  };
};
